/**
 * Post-login redirects must stay inside the app.
 *
 * React Router 6 treats a path like "/\evil.com" (or "//evil.com") as an
 * external URL in navigate()/<Link> (GHSA-wrjc-x8rr-h8h6, fixed only in v7), so
 * a crafted link to programrow.com/\evil.com could bounce a user off-site right
 * after they sign in. Only plain app paths pass; anything else falls back to
 * the caller's default.
 */
export function safeInternalPath(path: unknown): string | undefined {
  if (typeof path !== 'string' || path.length === 0) return undefined;
  if (!path.startsWith('/')) return undefined;
  if (path.startsWith('//')) return undefined;
  if (path.includes('\\')) return undefined;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(path)) return undefined;
  return path;
}
